(function(){
  'use strict';

  function initWCCare(){
    var productRoot=document.querySelector('[data-wc-product]');
    if(!productRoot) return;

    var titleNode=productRoot.querySelector('.wc-product__title');
    var productTitle=titleNode?titleNode.textContent.trim():'';
    var isHoodie=/hoodie|sweat/i.test(productTitle);
    if(isHoodie) return;

    var accordions=productRoot.querySelector('.wc-product__accordions');
    if(!accordions||accordions.querySelector('[data-wc-care]')) return;

    Array.prototype.slice.call(accordions.querySelectorAll('.wc-product__rte p')).forEach(function(paragraph){
      if(/^Pflege\s*:/i.test(paragraph.textContent.trim())) paragraph.remove();
    });

    if(!document.getElementById('WCCareStyles')){
      var style=document.createElement('style');
      style.id='WCCareStyles';
      style.textContent=''+
        '.wc-product__care-intro{margin:0 0 12px;color:#666;font-size:12.5px;line-height:1.55}'+
        '.wc-product__care-grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:8px;margin:0 0 11px}'+
        '.wc-product__care-card{min-height:78px;padding:12px 13px;background:#f3f0e9;display:flex;flex-direction:column;justify-content:flex-start}'+
        '.wc-product__care-card strong{display:block;margin:0 0 5px;color:#181818;font-size:10px;line-height:1.2;font-weight:800;letter-spacing:.11em;text-transform:uppercase}'+
        '.wc-product__care-card span{display:block;color:#67635e;font-size:11px;line-height:1.45}'+
        '.wc-product__care-note{margin:0!important;color:#918d86!important;font-size:9.5px!important;line-height:1.45!important}'+
        '@media screen and (max-width:380px){.wc-product__care-card{padding:11px}.wc-product__care-card span{font-size:10.5px}}';
      document.head.appendChild(style);
    }

    var care=document.createElement('details');
    care.setAttribute('data-wc-care','');
    care.innerHTML=''+
      '<summary>Pflege</summary>'+
      '<div class="wc-product__rte">'+
        '<p class="wc-product__care-intro">Vier einfache Regeln für Stoff und Print.</p>'+
        '<div class="wc-product__care-grid">'+
          '<div class="wc-product__care-card"><strong>30 °C waschen</strong><span>Auf links und mit ähnlichen Farben.</span></div>'+
          '<div class="wc-product__care-card"><strong>Kein Trockner</strong><span>Nicht im Trommeltrockner trocknen.</span></div>'+
          '<div class="wc-product__care-card"><strong>Max. 110 °C</strong><span>Auf links bügeln – niemals über den Print.</span></div>'+
          '<div class="wc-product__care-card"><strong>Schonend</strong><span>Nicht bleichen und nicht chemisch reinigen.</span></div>'+
        '</div>'+
        '<p class="wc-product__care-note">Bitte beachte zusätzlich das Pflegeetikett im Kleidungsstück.</p>'+
      '</div>';

    var shipping=null;
    Array.prototype.slice.call(accordions.querySelectorAll('details')).some(function(item){
      var summary=item.querySelector('summary');
      if(summary&&/Versand/i.test(summary.textContent)){shipping=item;return true;}
      return false;
    });
    if(shipping) accordions.insertBefore(care,shipping);
    else accordions.appendChild(care);
  }

  function initWCSizeGuide(){
  }

  function initWCEnhancements(){
    initWCCare();
    initWCSizeGuide();
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initWCEnhancements);
  else initWCEnhancements();
})();

